import React, { Fragment, useState, useEffect } from "react";
import { Card, Col, Button, Alert } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import '../../../../styles/balanco.scss'
import Moment from 'moment';

const Ouvidoria = (props) => {

    const [editar, setEditar] = useState(false);
    const [exibeBtn, setExibeBtn] = useState(false);
    const [exibeMsg, setExibeMsg] = useState(false);
    const [exibeMsg2, setExibeMsg2] = useState(false);
    const [passou, setPassou] = useState(false);
    const [id, setId] = useState("")

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const handleEditar = (id, passou, sit) => {
        if (sit === "Indeferido, justificado via mensagem" && passou === false) {
            // ✅ Caso certo — indeferido e dentro do prazo
            setId(id);
            setEditar(true);
            setExibeMsg(false);
            setExibeMsg2(false);
        } else if (sit === "Indeferido, justificado via mensagem" && passou === true) {
            // ⚠️ Indeferido, mas perdeu o prazo
            setExibeMsg(true);
            setExibeMsg2(false);
        } else {
            // ⚠️ Situação não é indeferimento → não cabe recurso
            setExibeMsg(false);
            setExibeMsg2(true);
        }
    };

    const dataAtualiza = Moment(props.requisicao.dataAtualiza).utc(false).format("DD [de] MMMM [de] YYYY")
    const dataPrev = Moment(props.requisicao.dataPrevisao).utc(false).format("DD [de] MMMM [de] YYYY")

    const verificaStatus = async (situacao) => {
        await verificaPassou()
        switch (situacao) {
            case 'Pendente':
            case 'Encaminhado à Secretaria Responsável':
            case 'Encaminhado à Autoridade Superior':
            case 'Encerrado':
                setExibeBtn(false);
            case 'Secretaria Responsável está atuando':
            case 'Recebido pela Prefeitura':
            case 'Resolvido':
            case 'Respondido':
            case 'Último Recurso':
            case '1º Recurso':
            case '2º Recurso':
            case 'Indeferido, justificado via mensagem':
                setExibeBtn(true);
                break;
            default:
                setExibeBtn(false);
                break;
        }
    }

    const verificaPassou = async () => {
        const datahj = Moment();
        const prev = Moment(props.requisicao.dataAtualiza).add(10, 'days');
        if (datahj > prev) {
            setPassou(true)
        }
    }

    useEffect(() => {
        verificaStatus(props.requisicao.situacao);
    }, [props.requisicao._id]);

    if (editar) {
        return (
            <Navigate to={`/ouvidoria/responder/${id}`} />
        )
    } else {
        return (
            <Fragment>
                <Col>
                    <Card className="card-list">
                        <Card.Header><h5>Sua requisição de protocolo: {props.requisicao._id}</h5></Card.Header>
                        <Card.Body>
                            <p>Situação: {props.requisicao.situacao}</p>
                            <p>Última atualização: {dataAtualiza}</p>
                            {props.requisicao.dataPrevisao ?
                                <p>Data máxima para resposta: {dataPrev}</p>
                                : null}
                            {props.requisicao.prorrogado ? <Alert variant="danger">
                                Sua requisição sofreu pedido de prorrogação de prazo de resposta!
                            </Alert> : null}
                            <h3>Histórico de mensagens:</h3>
                            {props.requisicao.respostas.length > 0 ? (
                                props.requisicao.respostas.slice().reverse().map((resposta, index) =>
                                    <Fragment key={index}>
                                        <p><strong>{resposta.quem} respondeu{resposta.dataResp ?  <span> em {Moment(resposta.dataResp).utc(false).format("DD [de] MMMM [de] YYYY")}:</span> : <span>:</span>}</strong></p>
                                        <p>{resposta.conteudo}</p>
                                        {resposta.anexo ? <a href={resposta.anexo} target="_blank">Anexo</a> : ''}
                                        <br />
                                        <br />
                                        {index === 0 &&
                                            resposta.quem === "Prefeitura Municipal de Macuco" && (
                                                <>
                                                    <Button
                                                        variant="primary"
                                                        onClick={() => handleEditar(props.requisicao._id, passou, props.requisicao.situacao)}
                                                    >
                                                        Abrir Recurso
                                                    </Button>

                                                    {exibeMsg && (
                                                        <Alert variant="warning" className="mt-3">
                                                            Conforme preconiza a LAI (Lei Nº12.527), o prazo máximo para abertura de recurso é de 10 (dez) dias após a última atualização por parte do órgão. Você ainda pode abrir uma nova solicitação <a href="https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria/cadastrar">clicando aqui</a>.
                                                        </Alert>
                                                    )}

                                                    {exibeMsg2 && (
                                                        <Alert variant="warning" className="mt-3">
                                                            Conforme preconiza a LAI (Lei Nº12.527), a abertura de recursos é reservada apenas para casos de indeferimento ou negativa de acesso à informação. Como a sua solicitação foi atendida, não é possível abrir um recurso. Caso deseje mais informações, basta abrir uma nova solicitação <a href="https://prefeituramacuco.rj.gov.br/transparencia/ouvidoria/cadastrar">clicando aqui</a>.
                                                        </Alert>
                                                    )}
                                                </>
                                            )}
                                        <hr />
                                    </Fragment>
                                )) : (
                                <p>Não há registro de mensagens até o momento nessa requisição!</p>)}
                        </Card.Body>
                    </Card>
                </Col>
            </Fragment >)
    }
}

export default Ouvidoria;